import axios from 'axios';
import host from '../global';

const getAuthHeader = () => ({
  Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
});

export const fetchConfigurationsService = async () => {
  const response = await axios.get(`${host}/get_configurations`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const fetchOrgDetailsService = async () => {
  const response = await axios.get(`${host}/getorgdetails`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const fetchVoicesService = async (language) => {
  const response = await axios.get(`${host}/voices`, {
    params: { language },
    headers: getAuthHeader(),
  });
  return response.data;
};

export const saveConfigService = async (params) => {
  const response = await axios.post(`${host}/save-config`, {}, {
    params,
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'application/json',
    },
  });
  return response;
};

export const saveWhitelabelConfigService = async (whitelabelData) => {
  const response = await axios.post(`${host}/api/save-whitelabel-config`, whitelabelData, {
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'application/json',
    },
  });
  return response;
};

export const uploadWhitelabelLogoService = async (file, logoType) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('logo_type', logoType);

  const response = await axios.post(`${host}/api/upload-whitelabel-logo`, formData, {
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const fetchEmailMonitorStatusService = async () => {
  const response = await axios.get(`${host}/email-monitor/status`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const toggleEmailMonitorService = async (action) => {
  await axios.patch(
    `${host}/email-monitor/toggle`,
    { action },
    { headers: getAuthHeader() },
  );
};

export const disconnectEmailMonitorService = async () => {
  await axios.delete(`${host}/email-monitor/disconnect`, {
    headers: getAuthHeader(),
  });
};

export const connectEmailMonitorPasswordService = async ({ email, app_password, provider }) => {
  await axios.post(
    `${host}/email-monitor/connect/password`,
    { email, app_password, provider },
    { headers: getAuthHeader() },
  );
};
